var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11C1 9.11438 1 8.17157 1.58579 7.58579C2.17157 7 3.11438 7 5 7H13C14.8856 7 15.8284 7 16.4142 7.58579C17 8.17157 17 9.11438 17 11V15C17 16.8856 17 17.8284 16.4142 18.4142C15.8284 19 14.8856 19 13 19H5C3.11438 19 2.17157 19 1.58579 18.4142C1 17.8284 1 16.8856 1 15V11Z",
    stroke: "#1D1D46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7V5C13 2.79086 11.2091 1 9 1V1C6.79086 1 5 2.79086 5 5V5.141",
    stroke: "#1D1D46",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.8149L9 15.7442",
    stroke: "#1D1D46",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 12.2559,
    r: 1.5,
    stroke: "#1D1D46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.71a359195160e6e5ca8e468cfaee335d.svg";
export { ForwardRef as ReactComponent };